import React from 'react'
import { Box, IconButton, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { gradientColors, textColors } from '../../Color/Color'

// Define the props interface for ModalHeader
interface ModalHeaderProps {
  title: string | React.ReactNode // Title of the modal
  onClose: () => void // Function to call when closing the modal
  hasCloseBtn?: boolean // Optional prop to show/hide the close button
  customHeaderStyle?: React.CSSProperties // Optional custom styles for the header
}

const ModalHeader: React.FC<ModalHeaderProps> = ({
  title,
  onClose,
  hasCloseBtn = true,
  customHeaderStyle = {},
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '16px',
        background: gradientColors.greenGradient,
        color: textColors.white,
        ...customHeaderStyle,
      }}
    >
      <Typography variant='h6'>{title}</Typography>
      {hasCloseBtn && (
        <IconButton
          aria-label='close'
          onClick={onClose}
          sx={{
            color: textColors.white,
          }}
        >
          <CloseIcon />
        </IconButton>
      )}
    </Box>
  )
}

export default ModalHeader
